import Measurer from 'models/Measurer';
import { atom } from 'recoil';

export const measurersConfigurationPending = atom<Measurer[]>({
  key: 'measurersConfigurationPending',
  default: [],
});
